import { useApiMutation } from '@/modules/common';

import { CreateModelBody, ModelsUploadUrlData } from '../types';

export function useCreateModel() {
  const uploadUrlDataMutation = useApiMutation<void, ModelsUploadUrlData>(
    '/models/upload-url',
    {
      method: 'GET',
    }
  );

  const createModelMutation = useApiMutation<CreateModelBody>('/models', {
    method: 'POST',
  });

  return {
    uploadUrlDataMutation,
    createModelMutation,
  } as const;
}
